import './App.css';
import Cabecalho from './componentes/Cabecalho';
import Container from 'react-bootstrap/Container';
import Introducao from './componentes/Introducao';
import Team from './componentes/Team';
import { useEffect, useRef, useState } from 'react';
import Parceiros from './componentes/Parceiros';
import Mapa from './componentes/Mapa';

import {ThemeProvider} from "styled-components";
import { GlobalStyles } from "./componentes/Globalstyle";
import { lightTheme, darkTheme } from "./componentes/Themes"

import {
  Routes, //replaces "Switch" used till v5
  Route,
  useNavigate,
  useLocation
} from "react-router-dom";
import Noticias from './componentes/Noticias';
import CaixaArredondada from './componentes/CaixaArredondada';
import Boletins from './componentes/Boletins';
import Login from './componentes/Login';
import Dashboards from './componentes/Dashboards';
import Mapa2 from './componentes/Mapa2';
import { useTranslation } from 'react-i18next';

//const [data, setData] = useState('en');

function HomeScreen(props){

  const [invertido, setInvertido] = useState(false);

  return (
      <Container className='background_body'>  
        <Introducao linguagem = {props.data}></Introducao>
        <div className='home-noticias'>
          <Noticias linguagem = {props.data}> </Noticias>
        </div>
        <Team linguagem = {props.data} theme = {props.theme} invertido = {invertido}></Team>
        <Parceiros linguagem = {props.data} theme = {props.theme} invertido = {invertido}></Parceiros>
      </Container>
  )
}

function App() {
  const navigate = useNavigate();
  const location = useLocation();

  const { i18n } = useTranslation();

  const [data, setData] = useState(localStorage.hasOwnProperty("language") ? 'en' : localStorage.getItem("language"));

  const [theme, setTheme] = useState(localStorage.hasOwnProperty("theme") ? 'dark' : localStorage.getItem("theme"));
  
  const [logado, setLogado] = useState(localStorage.hasOwnProperty("logado") ? false : localStorage.getItem("logado"));
  
  useEffect(() => {
    if (
      localStorage.getItem('theme') === 'light' ||
      (!('theme' in localStorage) &&
        window.matchMedia('(prefers-color-scheme: light)').matches)
    ) {
      setTheme('light')
    } else {
      setTheme('dark')
    }

    if (
      localStorage.getItem('language') === 'pt' ||
      (!('language' in localStorage))
    ) {
      setData('pt');
      i18n.changeLanguage('pt-BR');
    } else {
      setData('en');
      i18n.changeLanguage('en-US');
    }

}, [])
const childRef = useRef();

  const themeToggler = () => {
    if(theme === 'light'){
      setTheme('dark'); 
      localStorage.setItem("theme",'dark');
      childRef.current.refreshMap('dark');
    } else {
      setTheme('light');
      localStorage.setItem("theme",'light');
      childRef.current.refreshMap('light');
    }
  } 

  const childToParent = (childdata) => {
    setData(childdata)
    localStorage.setItem("language",childdata);
    childRef.current.refreshGraph(childdata);
  }

  const loginToParent = (childdata, rota) => {
    setLogado(childdata)
    localStorage.setItem("logado",childdata);
    if(!childdata)
      navigate("/login"); 
    else 
      navigate(rota);
  }

  return (
    <div className={location.pathname === "/" ? 'imagem_bg' : 'bg'} >
        <ThemeProvider theme={theme === 'light' ? lightTheme : darkTheme}>
        <>
          <Cabecalho childToParent={childToParent} themeToggler={themeToggler} theme = {theme} linguagem = {data} origem = {location.pathname} ocultaLinks = {location.pathname === "/mapa" || location.pathname === "/login"}></Cabecalho>
          <br></br>
          <br></br>
          <Container className="App">
              <GlobalStyles/>
    
              <Routes>
                  <Route path="/" element={<HomeScreen data = {data} theme = {theme} />} />
                  <Route path="/news" element={<Noticias data = {data}/>} />
                  <Route path="/login" element={<Login loginToParent={loginToParent} login = {logado} data = {data}/>} />
                  <Route path="/mapa" element={<Mapa data = {data} theme={theme} login = {logado} loginToParent={loginToParent} ref={childRef}/>} />
                  <Route path="/mapa2" element={<Mapa2 data = {data} theme={theme} login = {logado} loginToParent={loginToParent} ref={childRef}/>} />
                  <Route path="/boletins" element={<Boletins data = {data}/>} />
                  <Route path='/dashboards' element={<Dashboards data = {data} theme={theme} login = {logado} loginToParent={loginToParent}/>} />
              </Routes>     
          </Container>
        </>
      </ThemeProvider> 
    </div>
  );
}

export default App;
